import { combineReducers } from "redux";

// REDUCERS
import address from "./address";
import alert from "./alert";
import braze from "./braze";
import ccDetails from "./ccDetailsReducer";
import checkout from "./checkout";
import contactUsSetting from "./contactUsSettingReducer";
import country from "./countryReducer";
import currency from "./currencyReducer";
import customCakeTopper from "./customCakeTopper";
import doughPro from "./doughProReducer";
import elements from "./elementsReducer";
import experiments from "./experimentsReducer";
import footerSettings from "./footerSettingsReducer";
import giftCard from "./giftCard";
import loyalty from "./loyalty";
import optimisticCart from "./optimisticCart";
import order from "./order";
import orderExperiences from "./orderExperiencesReducer";
import orderTotalsTitles from "./orderTotalsTitles";
import payment from "./payment";
import product from "./productReducer";
import shipping from "./shippingReducer";
import siteSettings from "./siteSettings";
import theme from "./themeReducer";
import tips from "./tipsReducer";
import user from "./userReducer";
import guestUser from "./guestUserReducer";
import event from "./event";

export default combineReducers({
  elements,
  experiments,
  user,
  order,
  checkout,
  payment,
  address,
  doughPro,
  customCakeTopper,
  braze,
  shipping,
  country,
  currency,
  footerSettings,
  tips,
  ccDetails,
  siteSettings,
  giftCard,
  orderTotalsTitles,
  product,
  contactUsSetting,
  theme,
  loyalty,
  alert,
  orderExperiences,
  optimisticCart,
  guestUser,
  event,
});
